import { render, staticRenderFns } from "./modifyPwdComponent.vue?vue&type=template&id=5b001746"
import script from "./modifyPwdComponent.vue?vue&type=script&lang=js"
export * from "./modifyPwdComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports